<template>
  
  <router-view/>
</template>

<style>
nav {
  padding: 20px;
}
</style>
